module.exports = __webpack_public_path__ + "05_mustache_grey.bdfd19d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/05_mustache_grey.png
// module id = p8aK
// module chunks = 0